import React, { useState } from 'react';
import { CaretDown, CaretRight } from '@carbon/react/icons';
import { SourceDocumentResponse } from 'types/api-responses';
import { Date as DateComponent } from 'components/date';
import style from './edit-document-modal.module.scss';

interface SourceDocumentsSectionProps {
  sourceDocuments: SourceDocumentResponse[];
}

const fieldKeys = [
  'id',
  'documentId',
  'originalDocumentId',
  'source',
  'sourceId',
  'documentType',
  'effectiveDate',
  'recordedDate',
  'instrumentDate',
  'fileDate',
  'imagePath',
  'createdAt',
  'updatedAt',
  'countyId',
  'bookType',
  'volume',
  'page',
  'instrumentNumber',
];

const fields = fieldKeys.map((key) => ({
  key,
  label: key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase()),
}));

export const SourceDocumentsSection: React.FC<SourceDocumentsSectionProps> = ({
  sourceDocuments,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSection = () => {
    setIsOpen(!isOpen);
  };

  const formatValue = (doc: SourceDocumentResponse, key: string) => {
    const value = doc[key as keyof SourceDocumentResponse];

    if (value === null || value === undefined || value === '') {
      return '--';
    }

    if (key === 'createdAt' || key === 'updatedAt') {
      const date = new Date(value as string);
      return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }

    if (key.includes('Date') && value) {
      return <DateComponent date={value as string} />;
    }

    return value.toString();
  };

  return (
    <div className={style.sourceDocumentsSection}>
      <div className={style.sourceDocumentsHeader} onClick={toggleSection}>
        <div className={style.headerContent}>
          <span className={style.headerText}>
            Source Documents ({sourceDocuments.length})
          </span>
          <span className={style.chevron}>
            {isOpen ? <CaretDown /> : <CaretRight />}
          </span>
        </div>
      </div>
      {isOpen && (
        <div className={style.sourceDocumentsTable}>
          <div className={style.sourceDocumentsTableScroller}>
            <table className={style.verticalTable}>
              <colgroup>
                <col className={style.colLabel} />
                {sourceDocuments.map((_, index) => (
                  <col key={index} className={style.colDoc} />
                ))}
              </colgroup>
              <tbody>
                {fields.map((field) => (
                  <tr key={field.key}>
                    <td className={style.fieldLabel}>{field.label}</td>
                    {sourceDocuments.map((doc, index) => (
                      <td key={index} className={style.fieldValue}>
                        {formatValue(doc, field.key)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};
